import {BehaviorSubject} from "rxjs";
import {map} from "rxjs/operators";

interface StatusState {
    isLoading: boolean;
    isSuccessful: boolean;
}

/* Defining the default initial state of the store. */
const defaultInitialState: StatusState = {
    isLoading: false,
    isSuccessful: false,
}

/**
 * It creates a status store.
 * @param {StatusState} [initialState] - The initial state of the store.
 * @returns An object with the following properties:
 *     - isLoading$: An observable that emits the current value of the isLoading property of the state
 *     - isSuccessful$: An observable that emits the current value of the isSuccessful property of the state
 *     - setIsLoading: A function that takes a boolean and sets the isLoading property of the state to that value
 */
export const createStatusStore = (initialState?: StatusState) => {
    const stateSubject = new BehaviorSubject<StatusState>(initialState ?? defaultInitialState);
    const setIsLoading = (isLoading: boolean) => stateSubject.next({...stateSubject.value, isLoading});
    const setIsSuccessful = (isSuccessful: boolean) => stateSubject.next({...stateSubject.value, isSuccessful});
    const state$ = stateSubject.asObservable();

    const selectors = {
        isLoading$: state$.pipe(map(state => state.isLoading)),
        isSuccessful$: state$.pipe(map(state => state.isSuccessful)),
    };

    const actions = {
        setIsLoading,
        setIsSuccessful,
    }

    return {
        ...selectors,
        ...actions,
    }
}